var _rect, _text, _text2, _rect2, _text3, _g, _rect3, _text4, _g2, _rect4, _text5, _g3, _rect5, _text6, _g4, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase7Fig1OrchestrationSelfSimilarity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 592",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 592,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "One rule, repeated at four scales")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Producer, single writer, independent check: the shape holds from one agent up to the product itself")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 106,
    width: 804,
    height: 460,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 134,
    fontSize: 13,
    letterSpacing: "0.08em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "THE PRODUCT A CUSTOMER COMMISSIONS")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 158
  }, "producer: the agent doing the work"), /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 158
  }, "single writer: the settlement ledger"), /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 158
  }, "check: the judge"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 176,
    width: 708,
    height: 356,
    rx: 14,
    fill: "#FDFCF8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 204,
    fontSize: 13,
    letterSpacing: "0.08em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "THE OPERATING CADENCE")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 228
  }, "producer: one tick's work"), /*#__PURE__*/React.createElement("text", {
    x: 416,
    y: 228
  }, "single writer: the iteration log"), /*#__PURE__*/React.createElement("text", {
    x: 672,
    y: 228
  }, "check: the audit"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 246,
    width: 596,
    height: 252,
    rx: 12,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 274,
    fontSize: 13,
    letterSpacing: "0.08em",
    fill: "#16A34A",
    fontWeight: 600
  }, "A FAN-OUT WAVE")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 298
  }, "producer: N parallel agents"), /*#__PURE__*/React.createElement("text", {
    x: 448,
    y: 298
  }, "single writer: the loop"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 298
  }, "check: the gate"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 318,
    width: 476,
    height: 146,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 346,
    fontSize: 13,
    letterSpacing: "0.08em",
    fill: "#16A34A",
    fontWeight: 600
  }, "A SINGLE AGENT")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 372
  }, "producer: the agent"), /*#__PURE__*/React.createElement("text", {
    x: 428,
    y: 372
  }, "single writer: the orchestrator"), /*#__PURE__*/React.createElement("text", {
    x: 236,
    y: 394
  }, "check: the loop that dispatched it, then the suite"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 440,
    fontSize: 13,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontWeight: 500
  }, "The same three roles, at every scale.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase7Fig1OrchestrationSelfSimilarity);
export default __webpack_public_path__ + "static/media/case7-fig1-orchestration-self-similarity.a7d28e501dc3702b057ee6ec3adc9161.svg";
export { ForwardRef as ReactComponent };